module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-bg-1-30776a9d01b561b20da9cabf560eb7d6.png";